// removed by extract-text-webpack-plugin
module.exports = {"item":"src-components-ArchiveItem----styles-module---item---bWgBD","info":"src-components-ArchiveItem----styles-module---info---c6Xqc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ArchiveItem/styles.module.scss
// module id = 300
// module chunks = 63642485605921